import avatar0 from '../assets/images/avatars/circular_avatar_0_0.png';
import avatar1 from '../assets/images/avatars/circular_avatar_0_1.png';
import avatar2 from '../assets/images/avatars/circular_avatar_1_0.png';
import avatar3 from '../assets/images/avatars/circular_avatar_1_1.png';
import avatar4 from '../assets/images/avatars/circular_avatar_1_2.png';
import avatar5 from '../assets/images/avatars/circular_avatar_2_0.png';
import avatar6 from '../assets/images/avatars/circular_avatar_2_1.png';
import avatar7 from '../assets/images/avatars/circular_avatar_2_2.png';

export const avatarList = [
    { id: 0, src: avatar0 },
    { id: 1, src: avatar1 },
    { id: 2, src: avatar2 },
    { id: 3, src: avatar3 },
    { id: 4, src: avatar4 },
    { id: 5, src: avatar5 },
    { id: 6, src: avatar6 },
    { id: 7, src: avatar7 },
];